export const marigold = {
    marigold100: '#fbf9f5',
    marigold200: '#fef8e5',
    marigold300: '#fff2af',
    marigold400: '#ffe989',
    marigold500: '#ffde64',
    marigold600: '#f5d05d',
    marigold700: '#e2c25e',
    marigold800: '#d0aa2a',
    marigold900: '#ffdd36',
    marigold1000: '#ffd100',
    marigold1100: '#917000',
    marigold1200: '#463c1e',
    marigoldAccentContrast: '#292109',
    marigoldAccentSurface: '#fef9e6',
};

export const marigoldAlpha = {
    marigold100: 'rgba(221, 157, 29, 0.03)',
    marigold200: 'rgba(255, 246, 218, 0.67)',
    marigold300: '#fff2af',
    marigold400: '#ffe989',
    marigold500: '#ffde64',
    marigold600: 'rgba(241, 182, 0, 0.63)',
    marigold700: 'rgba(211, 160, 0, 0.63)',
    marigold800: 'rgba(199, 153, 0, 0.84)',
    marigold900: '#ffdd36',
    marigold1000: '#ffd100',
    marigold1100: '#917000',
    marigold1200: 'rgba(45, 34, 0, 0.88)',
    marigoldAccentContrast: '#292109',
    marigoldAccentSurface: 'rgba(255, 248, 224, 0.8)',
};

export const marigoldDark = {
    marigold100: '#13110c',
    marigold200: '#1b1811',
    marigold300: '#2a230e',
    marigold400: '#372b03',
    marigold500: '#433505',
    marigold600: '#504318',
    marigold700: '#5d5021',
    marigold800: '#6a5d2a',
    marigold900: '#776a33',
    marigold1000: '#84773c',
    marigold1100: '#918445',
    marigold1200: '#9e9150',
    marigoldAccentContrast: '#ffffff',
    marigoldAccentSurface: '#1b1811',
};

export const marigoldDarkAlpha = {
    marigold100: 'rgba(19, 17, 12, 0.01)',
    marigold200: 'rgba(27, 24, 17, 0.04)',
    marigold300: 'rgba(42, 35, 14, 0.11)',
    marigold400: 'rgba(55, 43, 3, 0.18)',
    marigold500: 'rgba(67, 53, 5, 0.24)',
    marigold600: 'rgba(80, 67, 24, 0.31)',
    marigold700: 'rgba(93, 80, 33, 0.38)',
    marigold800: 'rgba(106, 93, 42, 0.45)',
    marigold900: 'rgba(119, 106, 51, 0.7)',
    marigold1000: 'rgba(132, 119, 60, 0.65)',
    marigold1100: 'rgba(145, 132, 69, 0.83)',
    marigold1200: 'rgba(158, 145, 80, 0.96)',
    marigoldAccentContrast: '#ffffff',
    marigoldAccentSurface: 'rgba(27, 24, 17, 0.5)',
};
